import React, { useEffect, useState } from 'react'
import FiltersFlow from '../components/FiltersFlow'
import { CustomButton, FilterContainer } from './style'
import { FaFilter } from 'react-icons/fa'
import { MdCleaningServices } from 'react-icons/md'
import TableFlow from '../components/tableFlow'
import { FlowProps } from '../../../@types/flow'
import { allFluxos } from '../../../services/flow'
import Paginate from '../../../Components/Paginate'
import InpuSearch from './InputSearch'
import { CardFooterCustom } from '../style'
import { TbListSearch } from 'react-icons/tb'

const initialFilters = {
  filtro_ativo: {
    label: '',
    value: true
  },
  model: {
    label: '',
    value: ''
  },
  createdData: '',
  dataFim: '',
  service: '',
  orgao: {
    label: '',
    value: ''
  },
  title: '',
  organSelected: 0,
  organSlugSelected: '',
  cpf: '',
  protocol: '',
  flowSlug: '',
  atendente: '',
  servico_slug: {
    label: '',
    value: ''
  },
  setor: {
    label: '',
    value: ''
  },
};

interface FlowtabProps {
  filtersFlow: any,
  setFiltersFlow: any
}

const FlowTab = ({ setFiltersFlow }: FlowtabProps) => {
  const [loading, setLoading] = useState(false);
  const [flowData, setFlowData] = useState<FlowProps>();
  const [showFilters, setShowFilters] = useState(false);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState(initialFilters);
  const [servicesList, setServicesList] = useState<any>(null);
  const [serviceSelected, setServiceSelected] = useState<any>(null);
  const [shouldFetchAfterClean, setShouldFetchAfterClean] = useState(false);

  const fetchData = async ({ page }: { page: number }) => {
    setLoading(true);
    try {
      const allFluxosParams = {
        page: page,
        filtro_ativo: filters.filtro_ativo.value,
        active: filters.model.value,
        publico_especifico: undefined,
        orgao: filters.orgao.value,
        servico_slug: filters.servico_slug.value,
        modelo: filters.model.value,
        data: filters.createdData,
        titulo: search || filters.title,
      };

      const response = await allFluxos(
        allFluxosParams.page,
        allFluxosParams.titulo,
        allFluxosParams.active,
        allFluxosParams.filtro_ativo,
        allFluxosParams.publico_especifico,
        allFluxosParams.orgao,
        allFluxosParams.servico_slug,
        undefined,
        allFluxosParams.modelo,
        undefined,
        undefined,
        allFluxosParams.data
      );

      setFlowData(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setSearch("");
    setFilters(initialFilters);
    setServicesList([]);
    setServiceSelected('');
    setShouldFetchAfterClean(true);
  }

  useEffect(() => {
    fetchData({ page: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    setFiltersFlow({ ...filters, servicoSlug: filters.servico_slug })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const onChangeFilters = () => {
    setShowFilters(!showFilters)
  }

  useEffect(() => {
    if (shouldFetchAfterClean) {
      fetchData({ page: 1 });
      setShouldFetchAfterClean(false);
    }
  }, [shouldFetchAfterClean]);

  return (
    <>
      <InpuSearch
        setSearchData={setSearch}
        searchData={search}
        isSearch={search !== ""}
        onShowFilters={() => onChangeFilters()}
      />
      {showFilters && <FiltersFlow setServicesList={setServicesList} setFilters={setFilters} filters={filters} setServiceSelected={setServiceSelected} servicesList={servicesList} serviceSelected={serviceSelected} />}
      {showFilters && <FilterContainer>
        <CustomButton variant="filter" onClick={() => fetchData({ page: 1 })}>
          <FaFilter size={20} /> Filtrar
        </CustomButton>
        <CustomButton variant="clear" onClick={() => clearFilters()} >
          <MdCleaningServices size={20} /> Limpar
        </CustomButton>
      </FilterContainer>}
      <div className="d-flex align-items-center">
        <TbListSearch size="20" className="text-primary mr-2" />
        <strong style={{ marginRight: '5px', marginLeft: '3px' }}>{flowData?.count}</strong>
        <span>Fluxos encontrados</span>
      </div>
      {flowData && flowData.results && <TableFlow loading={loading} results={flowData.results} />}
      <CardFooterCustom>
        {flowData?.total_pages > 0 && (
          <Paginate
            flowData={flowData}
            setPage={fetchData}
            page={flowData?.current}
          />
        )}
      </CardFooterCustom>
    </>
  )
}

export default FlowTab